/**
 * The reminder bar for enquiries (13 Oct 2026), on every page but the book
 * itself: whoever keeps one is told the call backs owed today. The owner's
 * figure would be the whole book's, which is the Team view's to tell, so the
 * bar is for the people doing the calling.
 */
import { Link, useLocation } from 'react-router-dom';
import { PhoneCall } from 'lucide-react';

import { formatNumber } from '@/lib/format';
import { useEnquiryRole, useEnquirySummary } from './enquiries-api';

export function EnquiryNudge() {
  const location = useLocation();
  const role = useEnquiryRole();
  const reminds = role.keeps && !role.wholeBook;
  const summary = useEnquirySummary(reminds).data;
  if (!reminds || !summary || summary.due === 0 || location.pathname === '/enquiries') return null;
  return (
    <Link
      to="/enquiries"
      className="mb-3 flex items-center gap-3 rounded-md border border-line bg-surface-2 px-3 py-2 text-caption text-ink-2 hover:border-accent"
    >
      <PhoneCall className="h-4 w-4 shrink-0 text-accent" aria-hidden />
      <span className="min-w-0 flex-1">
        {formatNumber(summary.due)} {summary.due === 1 ? 'enquiry to call back' : 'enquiries to call back'} today.
      </span>
      <span className="shrink-0 font-medium text-accent">Open</span>
    </Link>
  );
}
